module.exports = __webpack_public_path__ + "static/Create_project-4ba194f0bf113160e87f5b1a19c3ef6a.png";